<div class="controls" [class.print]="print">
    <div class="header">
        <app-header
            [print]="print"
            [mainTitle]="title"
            [subTitle]="subtitle"
            [backLink]="backLink"
            [backQueryParams]="backQueryParams"
            (clicked)="headerClick.emit()">
        </app-header>
    </div>

    <div class="filters">
        <ng-content select="[filters]"></ng-content>
    </div>

    <div class="indicator">
        <ng-content select="[indicator]"></ng-content>
    </div>

    <div class="print-pdf">
        <ng-content select="[print-pdf]"></ng-content>
    </div>

    <div class="actions">
        <ng-content select="[actions]"></ng-content>
        <app-settings-menu
            [date]="date"
            [projectId]="projectId"
            [showPlanningFilter]="showPlanningFilter"
            [showHelpIcon]="showHelpIcon"
            (selectedTeams)="selectedTeams.emit($event)"
            (onOpenHelpClick)="onOpenHelpClick.emit()">
            <ng-content select="[menu-filters]"></ng-content>
        </app-settings-menu>
    </div>
</div>
